import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { APPOINTMENT_DESCRIPTION_MAX_LENGTH } from 'utils/constants';
import ToggleSwitchRow from '../ToggleSwitchRow/ToggleSwitchRow';
import { CreateOrEditServiceSubmitData } from '../CreateOrEditService';

interface ServiceDescriptionSectionProps {
  control: Control<CreateOrEditServiceSubmitData>;
  isEnabled?: boolean;
}

const LABEL = 'Service Description';

const ServiceDescriptionSection: FC<ServiceDescriptionSectionProps> = ({
  control,
  isEnabled,
}) => (
  <div className="flex flex-col gap-y-0.8">
    <ToggleSwitchRow
      control={control}
      name="isDescriptionEnabled"
      label={LABEL}
    />
    {isEnabled && (
      <Controller
        control={control}
        name="description"
        rules={{
          required: 'This field is required',
          maxLength: APPOINTMENT_DESCRIPTION_MAX_LENGTH,
        }}
        render={({ field, fieldState: { error } }) => (
          <div className="flex flex-col gap-y-0.8">
            <textarea
              aria-label={LABEL}
              placeholder="Describe this service for patients, e.g. what’s included, what to expect, who should book it, and anything to prepare or bring."
              rows={3}
              maxLength={APPOINTMENT_DESCRIPTION_MAX_LENGTH}
              className={`w-full resize-none text-14 leading-[2.1rem] py-1.3 pl-1.6 pr-4.5 rounded-[1rem] border-[0.5px] placeholder:text-mid-grey scrollbar !outline-none !ring-transparent ${
                error?.message
                  ? 'shadow-input-error border-[#f44336] hover:border-[#f44336] hover:shadow-input-error focus:border-[#f44336] focus:shadow-input-error'
                  : 'shadow-primary border-lightest-grey hover:border-magenta hover:shadow-input-active focus:border-magenta focus:shadow-input-active'
              }`}
              {...field}
              value={field.value ?? ''}
            />
            <span>
              {(field.value ?? '').length}/{APPOINTMENT_DESCRIPTION_MAX_LENGTH}{' '}
              characters
            </span>
            {error?.message && (
              <div className="flex items-center gap-x-1">
                <WarningIcon />
                <span className="text-12 text-red-01">{error.message}</span>
              </div>
            )}
          </div>
        )}
      />
    )}
  </div>
);

export default ServiceDescriptionSection;
